/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dayjs, dayjs } from '@mst-fe/shared/dayjs';

import { PreciseTime } from '../../_shared/views/preciseTimePicker/PreciseTime';
import { DataQueryConfig, DataQueryFormItem, WorkflowLoadingState } from '../pages/types';
import { AMERICA_NY_TIMEZONE } from './midas-constants';

const isProbablyADate = (date: string) => /^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.\d\d\dZ$/.test(date);

export const getDayjsOrNone = (date: string) => {
  if (!date) {
    return undefined;
  }
  return dayjs(date);
};

// this must be idempotent, as effects can be called twice by react
// rehydrate dates to dayjs
// I really, really don't like this at all.
export const fixDates = (config: DataQueryFormItem) => {
  const fiddleWithDates = (configItem: DataQueryFormItem) => {
    (Object.keys(configItem.config!) as unknown as (keyof DataQueryConfig)[]).forEach((key) => {
      const value: any = configItem.config![key];

      if (Array.isArray(value) && value.length > 0 && isProbablyADate(value[0] as string)) {
        configItem.config![key] = value.map((v) => dayjs(v)) as any;
      }
      if (typeof value === 'string' && isProbablyADate(value)) {
        configItem.config![key] = dayjs(value) as any;
      }

      // dayjs dates do have a `date` property, so make sure we don't mistake them for objects with schema { date: string; startTime: string; endTime: string; }
      if (value && !isDayjs(value) && value.date && !isDayjs(value.date)) {
        configItem.config![key] = {
          date: dayjs(value.date),
          startTime: value.startTime,
          endTime: value.endTime,
        } as any;
      }
    });
  };

  config.searchConfigs?.forEach(fiddleWithDates);
  config.previousSearches?.forEach(fiddleWithDates);

  return config;
};

export const anyEmpty = (parameters: URLSearchParams, toIgnore: string[] = []) => {
  for (const [key, value] of parameters.entries()) {
    if (toIgnore.includes(key)) {
      continue;
    }

    if (!value || value === 'undefined') {
      // this is OK, now.
      // console.warn('[anyEmpty] empty key! ', key);
      return true;
    }
  }

  return false;
};

export const coerceDateTime = (date: Dayjs | undefined, time: PreciseTime | undefined) => {
  if (!date || !time || time.isCleared || !time.hourIsSet) {
    return undefined;
  }

  return dayjs.tz(
    date.format('YYYYMMDD') + ' ' + time.hours + ':' + time.minutes + ':' + time.seconds + '.' + (time.milliseconds || 0),
    AMERICA_NY_TIMEZONE
  );
};

export const anyErrors = (values: WorkflowLoadingState[]) => values.some(({ error }) => error !== undefined);

export const anyLoading = (values: WorkflowLoadingState[]) => values.some(({ loading }) => loading === true);

// this is workaround for dayjs issue https://github.com/iamkun/dayjs/issues/2518
export const isDayjs: (d: unknown) => boolean = (date: unknown) => date && (dayjs.isDayjs(date) || (date as any).$isDayjsObject);
